/**
 * Browser Notification Service
 * Handles permission requests and displaying system-level alerts.
 */

export const NOTIFICATION_STORAGE_KEY = 'sohlocal_notifications_enabled';

export const checkNotificationSupport = () => {
  return (
    typeof window !== 'undefined' &&
    'Notification' in window &&
    'serviceWorker' in navigator
  );
};

export const getNotificationPermission = () => {
  if (!checkNotificationSupport()) return 'unsupported';
  return Notification.permission;
};

export const isNotificationPreferenceEnabled = () => {
  if (typeof window === 'undefined') return false;

  try {
    return localStorage.getItem(NOTIFICATION_STORAGE_KEY) === 'true';
  } catch {
    return false;
  }
};

export const requestNotificationPermission = async () => {
  if (!checkNotificationSupport()) return false;

  try {
    const permission = await Notification.requestPermission();

    if (permission === 'granted') {
      localStorage.setItem(NOTIFICATION_STORAGE_KEY, 'true');
      return true;
    }

    localStorage.setItem(NOTIFICATION_STORAGE_KEY, 'false');
    return false;
  } catch (error) {
    console.error('Error requesting notification permission:', error);
    return false;
  }
};

export const sendLocalNotification = (title, options = {}) => {
  if (
    !checkNotificationSupport() ||
    getNotificationPermission() !== 'granted' ||
    !isNotificationPreferenceEnabled() ||
    document.visibilityState !== 'hidden'
  ) {
    return null;
  }

  const {
    orderUrl,
    ...notificationOptions
  } = options;

  const defaultOptions = {
    icon: 'https://assets.sohlocal.com/Branding/Icon.png',
    badge: 'https://assets.sohlocal.com/Branding/Icon.png',
    silent: false,
    ...notificationOptions
  };

  const notification = new Notification(title, defaultOptions);

  if (orderUrl) {
    notification.onclick = () => {
      window.focus();
      window.location.assign(orderUrl);
      notification.close();
    };
  }

  return notification;
};

/**
 * Sound utility for notifications
 */
export const playNotificationSound = (type = 'message') => {
  const audio = new Audio(
    type === 'order'
      ? 'https://assets.mixkit.co/active_storage/sfx/2354/2354-preview.mp3'
      : 'https://assets.mixkit.co/active_storage/sfx/2358/2358-preview.mp3'
  );

  audio.volume = 0.4;
  audio.play().catch(() => console.log('Autoplay prevented'));
};